<template>
    <div id="login">
        <div style="height:1.35rem"></div>
        <div style="margin-bottom: 1.55rem;">
            <img src="../../image/login/logo.png" alt="" style="margin-left:4.01rem;width: 1.97rem;height:1.72rem;">
        </div>
        <div style="margin-left:1rem;">
            <div class="flex-start">
                <img src="../../image/login/account.png" alt="" style="margin-right:0.39rem;width:0.53rem;height:0.53rem;">
                <input class="loginInput" placeholder="请输入手机号" type="text" />
            </div>
            <div style="margin-top:0.31rem;width:8rem;height:1px;background:rgba(233,233,233,1);"></div>
        </div>
        <div style="margin-top:0.59rem;margin-left:1rem;">
            <div class="flex-start">
                <img src="../../image/login/password.png" alt="" style="margin-right:0.39rem;width:0.53rem;height:0.53rem;">
                <input class="loginInput" placeholder="请输入密码" type="password" />
            </div>
            <div style="margin-top:0.31rem;width:8rem;height:1px;background:rgba(233,233,233,1);"></div>
        </div>

        <div style="margin-left:1rem;margin-top:1.2rem;width:8rem;background:rgba(230,154,97,1);border-radius:0.59rem;height:1.17rem;line-height:1.17rem;text-align:center;font-size:0.48rem;font-family:PingFang SC;font-weight:500;color:rgba(255,255,255,1);">登录</div>

        <div style="position:absolute;bottom:0.73rem;width:10rem;height:0.31rem;line-height:0.31rem;text-align: center;font-size:0.32rem;font-family:PingFang SC;font-weight:400;color:rgba(153,153,153,1);">登录即代表您已同意<span style="color:#E69A61;"><span onclick="">用户协议</span>、<span onclick="">隐私协议</span></span></div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    export default {
        name: "login"
    }
</script>

<style scoped>
    #login{
        background-color:rgb(255,255,255);
        height: 100%;
        position: fixed;
        width: 100%;
    }
    .loginInput{
        width:7rem;
        height:0.53rem;
        line-height:0.53rem;
        background: transparent;
        border: none;
        font-size:0.43rem;
        font-family:PingFang SC;
        font-weight:500;
    }
    .loginInput::-webkit-input-placeholder{
        color:rgba(204,204,204,1);
    }



    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }




    .ellipsis-1{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .ellipsis-2{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .ellipsis-3{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
</style>
